import request from "./request";

const Usuario = {
  consultar: () => request.get("/usuarios"),
  cadastrar: usuario => request.post("/usuarios", usuario),
  excluir: id => request.del("/usuarios", { params: { id } }),
  alterar: usuario => request.put(`/usuarios/${usuario.id}`, usuario),
  buscar: id => request.get(`/usuarios/${id}`),
  obterLogado: login => request.get(`/usuarios/obter/${login}`),
  atualizarPerfil: usuario => request.put(`/usuarios/atualizar`, usuario)
};

export default Usuario;



// WEBPACK FOOTER //
// ./src/services/usuario.js